import ChatsCircle from '@components/Icons/ChatsCircle';
import Buttons from '@components/Buttons';
import { useFeatureFlag } from '@providers/FeatureFlags';
import classes from './UserWorkflowConversation.module.scss';

type Props = {
  isSelected: boolean;
  onClick: () => void;
};

const OpenConversationButton: React.FC<Props> = ({ isSelected, onClick }) => {
  const workflowConversationFeatureFlag = useFeatureFlag('workflow-conversation');
  if (!workflowConversationFeatureFlag) {
    return null;
  }

  return (
    <Buttons
      isWrapper
      onClick={onClick}
      style={{
        boxShadow: isSelected ? '0 0 0 2px var(--color-primary)' : '0 0 0 1px var(--color-gray-25)',
      }}
      className={classes['open-conversation-button']}
    >
      <ChatsCircle weight="fill" size={12} color="var(--color-primary)" />
      numberOfMessages
    </Buttons>
  );
};

export default OpenConversationButton;